import { createAction, props } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { Invitation } from '../models/invitation.model';

export const setInvitations = createAction('[Search Invitations Component] setSearchInvitations', props<Pagination<Invitation>>());

export const resetInvitations = createAction('[Search Invitations Component] ResetInvitations');
